import React from 'react';

import { bemBlock, Emblem, Text } from '@neptune/shared/venus-ui';

import './ExperimentalEmblem.less';

const block = bemBlock('experimental-emblem');

export const ExperimentalEmblem: React.FC = () => {
  return (
    <Emblem
      className={block()}
      color="info"
      size="sm"
      text={
        <Text size="xxs" className={block('text')}>
          Experimental
        </Text>
      }
    />
  );
};
